import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import DownloadIcon from '@mui/icons-material/Download';
import useDictionary from '@ui/hooks/useDictionary';
import {
    IProps as IMainProps,
    IClasses as IMainClasses,
} from './Footer.component';

interface IClasses
    extends Pick<
        IMainClasses,
        | 'tooltipPopper'
        | 'tooltip'
        | 'btnDownload'
        | 'btnVisibility'
        | 'btnBar'
        | 'ico'
    > {}

interface IProps
    extends Pick<
        IMainProps,
        | 'lang'
        | 'hideSettings'
        | 'hideDownload'
        | 'onDownloadClick'
        | 'onVisibilitySettingsStateChange'
    > {
    classes?: IClasses;
}

const Component: React.FC<IProps> = ({
    classes,
    hideSettings,
    hideDownload,
    onDownloadClick,
    onVisibilitySettingsStateChange,
}: IProps) => {
    const emptyFn = () => {};
    const getWord = useDictionary();
    const downloadBtn = (
        <Tooltip
            classes={{
                popper: classes?.tooltipPopper ?? 'telemetry__tooltip-popper',
                tooltip: classes?.tooltip ?? 'telemetry__tooltip',
            }}
            title={getWord('download')}
            placement="top"
        >
            <IconButton
                className={classes?.btnDownload ?? 'telemetry__btn_download'}
                onClick={onDownloadClick}
            >
                <DownloadIcon className={classes?.ico ?? 'telemetry__ico'} />
            </IconButton>
        </Tooltip>
    );
    const visibilityBtn = (
        <Tooltip
            classes={{
                popper: classes?.tooltipPopper ?? 'telemetry__tooltip-popper',
                tooltip: classes?.tooltip ?? 'telemetry__tooltip',
            }}
            title={getWord('visibilitySettings')}
            placement="top"
        >
            <IconButton
                className={
                    classes?.btnVisibility ?? 'telemetry__btn_visibility'
                }
                onClick={onVisibilitySettingsStateChange ?? emptyFn}
            >
                <SettingsIcon className={classes?.ico ?? 'telemetry__ico'} />
            </IconButton>
        </Tooltip>
    );

    return (
        <Box className={classes?.btnBar ?? 'telemetry__btn-bar'}>
            {!hideDownload && downloadBtn}
            {!hideSettings && visibilityBtn}
        </Box>
    );
};

const ToolbarComponent = React.memo(Component);

export default ToolbarComponent;
